import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { UtilService } from '../../services/util.service';

@Pipe({
  name: 'japDate'
})
export class JapDatePipe implements PipeTransform {
  constructor( private util: UtilService) {

  }
  // Format YYYY/MM/DD

  transform(value: any): any {
    if (value && value !== '') {
      const format = 'YYYY/MM/DD';
      const date = moment(value, format);
      const year = date.format('YYYY');
      const era = this.util.findEra(date);
      if (era.Char) {
        const jaYear = Number(year) - era.Diff;
        let dateOutput =  era.Char + this.util.padNumber(jaYear.toString(), 2);
        dateOutput += date.format('/MM/DD');
        return dateOutput;
      }
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/jap-date.pipe.ts